import { gql } from '@apollo/client/core';

export const UPSERT_GROK_INTERACTION = gql`
  mutation UpsertGrokInteraction($input: UpsertGrokInteractionInput!) {
    upsertGrokInteraction(input: $input) {
      response
    }
  }
`;
